import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../../../Hooks/usePageTitle';
import { getBlockedUsers } from '../../../Services/User/BlockedUsers';

import InnerBanner from '../../../Components/InnerBanner/InnerBanner';
import './BlockedUsers.css';

const BlockedUsers = () => {
  usePageTitle('Blocked Users');

  const navigate = useNavigate();
  const { data: user, isLoading } = useQuery({
    queryKey: ['blocked-users'],
    queryFn: getBlockedUsers,
  });

  if (isLoading) {
    return (
      <>
        <InnerBanner heading="Blocked Users" />
        <section className="py-sm-5 py-4">
          <Container>
            <Row>
              <Col xs={12} className="text-center">
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-3">Loading blocked users...</p>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }

  if (!user?.data || user.data.length === 0) {
    return (
      <>
        <InnerBanner heading="Blocked Users" />
        <section className="py-sm-5 py-4">
          <Container>
            <Row>
              <Col xs={12} className="text-center">
                <p className="mt-3">No blocked users</p>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }

  return (
    <>
      <InnerBanner heading="Blocked Users" />
      <section className="py-sm-5 py-4">
        <Container>
          <Row>
            <Col xs={12} className="my-3">
              <div className="table-responsive">
                <table className="table customTable text-center">
                  <thead>
                    <tr>
                      <th>S.No.</th>
                      <th>Username</th>
                      <th>Status</th>
                      <th>Wants To</th>
                    </tr>
                  </thead>
                  <tbody>
                    {user?.data?.map((user, index) => (
                      <tr key={user.id}>
                        <td>{index < 9 ? `0${index + 1}` : index + 1}</td>
                        <td>{user.username}</td>
                        <td><span className={`chip ${user.status === 'blocked' ? 'red-text' : 'green-text'}`}>{user.status}</span></td>
                        <td><button className="primary-text transparent-btn">Unblock</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BlockedUsers;
